module.exports = __webpack_public_path__ + "img/23.1d43f80e.png";